<template>
  <v-app>
    <LibAuthHeader />
    <v-main :class="{ isMobile: isMobile }">
      <div class="content-padd-s">
        <div class="content-width layout">
          <div class="layout-left">
            <v-slide-x-transition mode="out-in">
              <router-view />
            </v-slide-x-transition>
          </div>
          <div class="layout-right" v-if="!isMobile">
            <img
              class="banner-img block"
              alt="Banner EDB"
              src="/img/banner-auth.svg"
            />
          </div>
        </div>
      </div>

      <CookieBanner></CookieBanner>
    </v-main>
    <LibAuthFooter />
  </v-app>
</template>

<script>
import CookieBanner from "./components/CookieBanner.vue";
import LibAuthHeader from "@/components/library/layout/LibAuthHeader.vue";
import LibAuthFooter from "@/components/library/layout/LibAuthFooter.vue";

export default {
  name: "App",
  components: { LibAuthHeader, LibAuthFooter, CookieBanner },

  data: () => ({})
};
</script>

<style scoped lang="scss">
.layout {
  margin: auto;
  display: flex;
  gap: 20px;
}
.layout-left {
  flex-basis: 448px;
  max-width: 100%;
}
.layout-right {
  flex: 1 0;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  .banner-img {
    display: block;
    max-width: 540px;
    width: 90%;
  }
}
.layout-left,
.layout-right {
  position: relative;
}
.isMobile {
}
</style>
